export default {
  // 検索
  templateName: 'テンプレート名',
  templateNamePlaceholder: 'テンプレート名を入力してください',
  productName: '製品名',
  productNamePlaceholder: '製品名を入力してください',
  // テーブル列
  colTemplateName: 'テンプレート名',
  colRelatedProduct: '関連製品',
  colIsDefault: 'デフォルトテンプレート',
  // デフォルトテンプレート
  defaultOn: 'オン',
  defaultOff: 'オフ',
  defaultOnSuccess: 'デフォルトテンプレートに設定しました',
  defaultOffSuccess: 'デフォルトテンプレートを無効にしました',
  defaultChangeFailed: 'デフォルトテンプレートの状態更新に失敗しました',
  // 操作
  editTemplate: 'テンプレート編集',
  addProduct: '製品追加',
  // 製品追加モーダル
  addProductTitle: '関連製品を追加',
  selectProduct: '製品を選択',
  selectProductPlaceholder: '製品を選択してください',
  productRequired: '製品を選択してください',
  addProductSuccess: '製品を追加しました',
  addProductFailed: '製品の追加に失敗しました',
  // 製品削除
  deleteProductSuccess: '製品を削除しました',
  deleteProductFailed: '製品の削除に失敗しました',
  // テンプレート編集
  editTemplateSuccess: 'テンプレートを更新しました',
  editTemplateFailed: 'テンプレートの更新に失敗しました',
  // 関連製品モーダル
  viewProductsTitle: '関連製品一覧',
  colProductId: '製品ID',
  colProductName: '製品名',
  // 空状態
  emptyText: 'テンプレートデータがありません',
};
